export default __webpack_public_path__ + "static/media/tv-text.46db2888.png";